// 자동 생성된 시험 데이터
// 생성 시간: 2025-08-08 13:39:15
// 시험: architectural-engineer 2024년 3회

export const examSession = {
  "examInfo": {
    "title": "2024년 architectural-engineer 필기시험 3회",
    "subject": "architectural-engineer",
    "year": 2024,
    "session": 3,
    "totalQuestions": 100,
    "examDate": "2025-08-08",
    "generatedAt": "2025-08-08T13:39:15.742112",
    "imageBasePath": "/images/architectural-engineer/2024/session-3/"
  },
  "questions": [
    {
      "id": 1,
      "questionNumber": 1,
      "questionText": "공장건축의 레이아웃 계획에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "플랜트 레이아웃은 공장건축의 기본설계와 병행하여 이루어진다.",
        "고정식 레이아웃은 조선소와 같이 제품이 크고 수량이 적을 경우에 적용한다.",
        "다품종 소량생산이나 주문생산 위주의 공장에는 공정 중심의 레이아웃이 적합하다.",
        "레이아웃 계획은 작업장내의 기계설비 배치에 관한 것으로 공장 규모변화에 따른 융통성은 고려대상이 아니다."
      ],
      "correctAnswer": 4,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "레이아웃 계획은 공장 규모변화에 따른 융통성도 중요한 고려사항입니다. 미래의 확장이나 축소 가능성을 고려하여 유연한 배치가 필요합니다.",
      "tags": [
        "공장건축",
        "레이아웃",
        "계획"
      ],
      "hasImage": false
    },
    {
      "id": 2,
      "questionNumber": 2,
      "questionText": "미술관 건축계획에 관한 설명으로 옳은 것은?",
      "options": [
        "하모니카 전시기법은 동일 종류의 전시물을 반복 전시할 경우 유리하다.",
        "연속순회형식이 가장 이상적으로 반영되어 있는 건축물로는 뉴욕의 구겐하임 미술관이 있다.",
        "미술관의 채광방식을 편측창방식으로 할 경우 실 전체의 조도분포가 균일하여 별도의 조명설비가 필요없다.",
        "아일랜드 전시기법은 벽이나 천장을 직접 이용하여 전시물을 배치하는 기법으로 관람자의 시거리를 짧게 할 수 없다는 단점이 있다."
      ],
      "correctAnswer": 1,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "하모니카 전시기법은 동일한 종류의 전시물을 반복적으로 전시할 때 효과적인 방법입니다. 구겐하임 미술관은 연속순회형식의 대표적 사례입니다.",
      "tags": [
        "미술관",
        "전시기법",
        "건축계획"
      ],
      "hasImage": false
    },
    {
      "id": 3,
      "questionNumber": 3,
      "questionText": "각 사찰에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "부석사의 가람배치는 누하진입형식을 취하고 있다.",
        "화엄사는 경사된 지형을 수단(數段)으로 나누어서 정지(整地)하여 건물을 적절히 배치하였다.",
        "통도사는 산지에 위치하나 산지가람처럼 건물들을 불규칙하게 배치하지 않고 직교식으로 배치하였다.",
        "봉정사 가람배치는 대지가 3단으로 나누어져 있으며 상단부분에 대웅전과 극락전 등 중요한 건물들이 배치되어 있다."
      ],
      "correctAnswer": 3,
      "subject": "건축계획",
      "difficulty": "hard",
      "explanation": "통도사는 산지가람의 특성을 보여주는 대표적인 사찰로, 지형에 맞춰 불규칙하게 배치된 자연스러운 가람배치를 가지고 있습니다.",
      "tags": [
        "한국건축",
        "사찰",
        "가람배치"
      ],
      "hasImage": false
    },
    {
      "id": 4,
      "questionNumber": 4,
      "questionText": "극장의 음향계획에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "반사음의 집중이 없도록 한다.",
        "무대 근처에는 음의 반사재를 취한다.",
        "불필요한 음은 적당히 감쇠시키고 필요한 음의 청취에 방해가 되지 않게 한다.",
        "천장계획에 있어서 돔(dome)형은 음원의 위치여하를 막론하고 음을 확산시키므로 바람직하다."
      ],
      "correctAnswer": 4,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "돔형 천장은 음을 한 점으로 집중시키는 특성이 있어 음향적으로 바람직하지 않습니다. 음의 확산을 위해서는 다른 형태의 천장이 적합합니다.",
      "tags": [
        "극장",
        "음향계획",
        "천장"
      ],
      "hasImage": false
    },
    {
      "id": 5,
      "questionNumber": 5,
      "questionText": "종합병원의 건축계획에 대한 설명 중 옳지 않은 것은?",
      "options": [
        "부속진료부는 외래환자 및 입원환자 모두가 이용하는 곳이다.",
        "간호사 대기소는 각 간호단위 또는 각층 및 동별로 설치한다.",
        "집중식 병원건축에서 부속진료부와 외래부는 주로 건물의 저층부에 구성된다.",
        "외래진료부의 운영방식에 있어서 미국의 경우는 대개 클로즈드 시스템인데 비하여, 우리나라는 오픈 시스템이다."
      ],
      "correctAnswer": 4,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "미국은 오픈 시스템을, 우리나라는 클로즈드 시스템을 주로 사용합니다. 클로즈드 시스템은 의사가 고정된 진료실에서 환자를 진료하는 방식입니다.",
      "tags": [
        "병원",
        "진료부",
        "운영방식"
      ],
      "hasImage": false
    },
    {
      "id": 6,
      "questionNumber": 6,
      "questionText": "다음 중 주심포식 건물이 아닌 것은?",
      "options": [
        "강릉 객사문",
        "서울 남대문",
        "수덕사 대웅전",
        "무위사 극락전"
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "hard",
      "explanation": "서울 남대문(숭례문)은 다포식 건물입니다. 주심포식은 기둥 위에만 공포를 두는 방식이고, 다포식은 기둥 사이에도 공포를 두는 방식입니다.",
      "tags": [
        "한국건축",
        "공포",
        "주심포식"
      ],
      "hasImage": false
    },
    {
      "id": 7,
      "questionNumber": 7,
      "questionText": "백화점 매장에 에스컬레이터를 설치할 경우, 설치 위치로 가장 알맞은 곳은?",
      "options": [
        "매장의 한 쪽 측면",
        "매장의 가장 깊은 곳",
        "백화점의 계단실 근처",
        "백화점의 주출입구와 엘리베이터 존의 중간"
      ],
      "correctAnswer": 4,
      "subject": "건축계획",
      "difficulty": "easy",
      "explanation": "에스컬레이터는 고객의 동선을 고려하여 주출입구와 엘리베이터 존의 중간에 설치하는 것이 가장 효율적입니다.",
      "tags": [
        "백화점",
        "에스컬레이터",
        "동선계획"
      ],
      "hasImage": false
    },
    {
      "id": 8,
      "questionNumber": 8,
      "questionText": "상점의 판매방식에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "측면판매방식은 직원동선의 이동성이 많다.",
        "대면판매방식은 측면판매방식에 비해 상품 진열 면적이 넓어진다.",
        "측면판매방식은 고객이 직접 진열된 상품을 접촉할 수 있는 관계로 선택이 용이하다.",
        "대면판매방식은 쇼 케이스를 중심으로 판매원이 고정된 자리나 위치를 확보하는 것이 용이하다."
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "대면판매방식은 측면판매방식에 비해 상품 진열 면적이 좁아집니다. 측면판매방식이 더 많은 상품을 진열할 수 있습니다.",
      "tags": [
        "상점",
        "판매방식",
        "진열"
      ],
      "hasImage": false
    },
    {
      "id": 9,
      "questionNumber": 9,
      "questionText": "호텔의 건축계획에 관한 설명 중 옳지 않은 것은?",
      "options": [
        "객실의 크기는 대지나 건물의 형태에 영향을 받지 않는다.",
        "기준층의 객실수는 기준층의 면적이나 기둥간격의 구조적인 문제에 영향을 받는다.",
        "로비는 퍼블릭 스페이스의 중심으로 휴식, 면회, 담화, 독서 등 다목적으로 사용되는 공간이다.",
        "주식당(Main Dining Room)은 숙박객 및 외래객을 대상으로 하며 외래객이 편리하게 이용할 수 있도록 출입구를 별도로 설치한다."
      ],
      "correctAnswer": 1,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "객실의 크기는 대지나 건물의 형태에 영향을 받습니다. 대지의 형태나 건물의 구조적 제약에 따라 객실 크기가 결정됩니다.",
      "tags": [
        "호텔",
        "객실",
        "건축계획"
      ],
      "hasImage": false
    },
    {
      "id": 10,
      "questionNumber": 10,
      "questionText": "건축물과 양식의 연결이 옳지 않은 것은?",
      "options": [
        "노트르담 성당 - 고딕양식",
        "샤르트르 성당 - 고딕양식",
        "피사의 사탑 - 바로크양식",
        "성 소피아 성당 - 비잔틴양식"
      ],
      "correctAnswer": 3,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "피사의 사탑은 로마네스크 양식입니다. 바로크 양식은 16-17세기의 건축양식으로 피사의 사탑보다 훨씬 후대의 양식입니다.",
      "tags": [
        "서양건축사",
        "건축양식",
        "역사"
      ],
      "hasImage": false
    },
    {
      "id": 11,
      "questionNumber": 11,
      "questionText": "사무소건축의 엘리베이터계획에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "군관리운전의 경우 동일 군내의 서비스층은 같게 한다.",
        "승객의 층별 대기시간은 평균 운전간격 이하가 되게 한다.",
        "실내공간의 확장을 용이하게 할 수 있도록 건축물의 한 쪽 끝에 설치한다.",
        "초고층, 대규모 빌딩인 경우는 서비스그룹을 분할(조닝)하는 것을 검토한다."
      ],
      "correctAnswer": 3,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "엘리베이터는 건물의 중앙부에 설치하는 것이 효율적입니다. 한쪽 끝에 설치하면 동선이 길어지고 비효율적입니다.",
      "tags": [
        "사무소",
        "엘리베이터",
        "계획"
      ],
      "hasImage": false
    },
    {
      "id": 12,
      "questionNumber": 12,
      "questionText": "건축계획단계에서의 조사방법에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "설문조사를 통하여 생활과 공간간의 대응관계를 규명하는 것은 생활행동 행위의 관찰에 해당된다.",
        "주거단지에서 어린이들의 행동특성을 조사하기 위해서는 생활행동 행위 관찰방식이 일반적으로 적절하다.",
        "이용상황이 명확하게 기록되어 있는 시설의 자료 등을 활용하는 것은 기존자료를 통한 조사에 해당 된다.",
        "건물의 이용자를 대상으로 설문을 작성하여 조사하는 방식은 생활과 공간의 대응관계 분석에 유효하다."
      ],
      "correctAnswer": 1,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "설문조사는 생활행동 행위의 관찰이 아닌 의식조사에 해당됩니다. 실제 행동을 관찰하는 것과는 다른 조사방법입니다.",
      "tags": [
        "건축계획",
        "조사방법",
        "설문조사"
      ],
      "hasImage": false
    },
    {
      "id": 13,
      "questionNumber": 13,
      "questionText": "은행의 주출입구에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "겨울철의 방풍을 위해 방풍실을 설치하는 것이 좋다.",
        "내부와 면한 출입문은 도난방지상 바깥여닫이로 하는 것이 좋다.",
        "이중문을 설치하는 경우, 바깥문은 바깥여닫이 또는 자재문으로 계획할 수 있다.",
        "어린이들의 출입이 많은 곳에서는 안전을 고려하여 회전문 설치를 배제하는 것이 좋다."
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "은행의 내부 출입문은 비상시 피난을 고려하여 안여닫이로 하는 것이 바람직합니다. 바깥여닫이는 피난에 불리합니다.",
      "tags": [
        "은행",
        "출입구",
        "보안"
      ],
      "hasImage": false
    },
    {
      "id": 14,
      "questionNumber": 14,
      "questionText": "사무소건축에서 오피스 랜드스케이핑에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "대형가구 등 소리를 반향시키는 기재의 사용이 어렵다.",
        "작업장의 집단을 자유롭게 그루핑하여 불규칙한 평면을 유도한다.",
        "변화하는 작업의 패턴에 따라 조절이 가능하며 신속하고 경제적으로 대처할 수 있다.",
        "개실시스템의 한 형식으로 배치를 의사전달과 작업흐름의 실제적 패턴에 기초를 둔다."
      ],
      "correctAnswer": 4,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "오피스 랜드스케이핑은 개실시스템이 아닌 오픈 오피스 시스템의 한 형태입니다. 칸막이 없는 개방된 공간이 특징입니다.",
      "tags": [
        "사무소",
        "오피스 랜드스케이핑",
        "공간계획"
      ],
      "hasImage": false
    },
    {
      "id": 15,
      "questionNumber": 15,
      "questionText": "학교 운영방식에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "달톤형은 다양한 크기의 교실이 요구된다.",
        "교과교실형은 각 교과교실의 순수율이 낮다는 단점이 있다.",
        "플래툰형은 교사수 및 시설이 부족하면 운영이 곤란하다는 단점이 있다.",
        "종합교실형은 학생의 이동이 없으며, 초등학교 저학년에 적합한 형식이다."
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "교과교실형은 각 교과교실의 순수율이 높습니다. 전용교실로 사용되므로 시설의 활용도가 높다는 장점이 있습니다.",
      "tags": [
        "학교",
        "운영방식",
        "교실"
      ],
      "hasImage": false
    },
    {
      "id": 16,
      "questionNumber": 16,
      "questionText": "타운 하우스에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "각 세대마다 주차가 용이하다.",
        "프라이버시 확보를 위한 경계벽 설치가 가능하다.",
        "단독주택의 장점을 고려한 형식으로 토지이용의 효율성이 높다.",
        "일반적으로 1층은 침실 등 개인공간, 2층은 거실 등 생활공간으로 구성한다."
      ],
      "correctAnswer": 4,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "타운하우스는 일반적으로 1층에 거실, 주방 등 공용공간을, 2층에 침실 등 개인공간을 배치합니다.",
      "tags": [
        "타운하우스",
        "주거계획",
        "공간구성"
      ],
      "hasImage": false
    },
    {
      "id": 17,
      "questionNumber": 17,
      "questionText": "공동주택 단지안의 도로의 설계속도는 최대 얼마 이하가 되도록 하여야 하는가?",
      "options": [
        "10km/h",
        "15km/h",
        "20km/h",
        "30km/h"
      ],
      "correctAnswer": 3,
      "subject": "건축계획",
      "difficulty": "easy",
      "explanation": "공동주택 단지 내 도로의 설계속도는 보행자 안전을 위해 최대 20km/h 이하로 제한됩니다.",
      "tags": [
        "공동주택",
        "도로",
        "설계속도"
      ],
      "hasImage": false
    },
    {
      "id": 18,
      "questionNumber": 18,
      "questionText": "아파트에 의무적으로 설치하여야 하는 장애인·노인·임산부 등의 편의시설에 속하지 않는 것은?",
      "options": [
        "점자블록",
        "장애인전용주차구역",
        "높이 차이가 제거된 건축물 출입구",
        "장애인 등의 통행이 가능한 접근로"
      ],
      "correctAnswer": 1,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "점자블록은 아파트에 의무 설치 대상이 아닙니다. 주로 공공건물이나 상업시설에 설치가 의무화되어 있습니다.",
      "tags": [
        "아파트",
        "편의시설",
        "장애인"
      ],
      "hasImage": false
    },
    {
      "id": 19,
      "questionNumber": 19,
      "questionText": "도서관의 출납시스템 중 열람자는 직접 서가에 면하여 책의 체제나 표지 정도는 볼 수 있으나 내용을 보려면 관원에게 요구하여 대출기록을 남긴 후 열람하는 형식은?",
      "options": [
        "폐가식",
        "반개가식",
        "안전개가식",
        "자유개가식"
      ],
      "correctAnswer": 2,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "반개가식은 서가를 볼 수는 있지만 직접 접근할 수 없어 관원의 도움이 필요한 시스템입니다.",
      "tags": [
        "도서관",
        "출납시스템",
        "반개가식"
      ],
      "hasImage": false
    },
    {
      "id": 20,
      "questionNumber": 20,
      "questionText": "다음과 같은 특징을 갖는 부엌의 평면형은?\n• 작업시 몸을 앞뒤로 바꾸어야 하는 불편이 있다.\n• 식당과 부엌이 개방되지 않고 외부로 통하는 출입구가 필요한 경우에 많이 쓰인다.",
      "options": [
        "일렬형",
        "ㄱ자형",
        "병렬형",
        "ㄷ자형"
      ],
      "correctAnswer": 3,
      "subject": "건축계획",
      "difficulty": "medium",
      "explanation": "병렬형 부엌은 양쪽에 작업대가 있어 작업시 몸을 돌려야 하는 불편함이 있으며, 독립된 부엌 형태에 많이 사용됩니다.",
      "tags": [
        "주택",
        "부엌",
        "평면형"
      ],
      "hasImage": false
    },
    {
      "id": 21,
      "questionNumber": 21,
      "questionText": "시험말뚝을 박을 때에 허용지지력 산출에 별로 영향을 주지 않는 것은?",
      "options": [
        "추의 낙하높이",
        "말뚝의 최종관입량",
        "말뚝의 길이",
        "추의 무게"
      ],
      "correctAnswer": 3,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "말뚝의 길이는 허용지지력 산출에 직접적인 영향을 주지 않습니다. 추의 무게, 낙하높이, 최종관입량이 주요 인자입니다.",
      "tags": [
        "말뚝",
        "지지력",
        "시험말뚝"
      ],
      "hasImage": false
    },
    {
      "id": 22,
      "questionNumber": 22,
      "questionText": "린건설(Lean Construction)에서의 관리방법으로 옳지 않은 것은?",
      "options": [
        "변이관리",
        "당김생산",
        "흐름생산",
        "대량생산"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "린건설은 낭비를 제거하고 효율성을 높이는 관리방법으로, 대량생산보다는 필요에 따른 당김생산을 지향합니다.",
      "tags": [
        "린건설",
        "관리방법",
        "생산방식"
      ],
      "hasImage": false
    },
    {
      "id": 23,
      "questionNumber": 23,
      "questionText": "다음 중 사용할 때 마다 부재의 조립, 분해를 반복하지 않아 벽식구조인 아파트 건축물에 적용효과 큰 대형 벽체 거푸집은?",
      "options": [
        "Gang form",
        "Sliding form",
        "Air tube form",
        "Traveling form"
      ],
      "correctAnswer": 1,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "Gang form은 대형 벽체용 거푸집으로 조립·분해 없이 크레인으로 이동하여 재사용할 수 있어 효율적입니다.",
      "tags": [
        "거푸집",
        "Gang form",
        "벽식구조"
      ],
      "hasImage": false
    },
    {
      "id": 24,
      "questionNumber": 24,
      "questionText": "압연강재가 냉각될 때 표면에 생기는 산화철 표피를 무엇이라 하는가?",
      "options": [
        "스패터",
        "밀스케일",
        "슬래그",
        "비드"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "easy",
      "explanation": "밀스케일(Mill Scale)은 압연강재가 냉각될 때 표면에 생기는 산화철 표피로, 도장 전에 제거해야 합니다.",
      "tags": [
        "강재",
        "밀스케일",
        "표면처리"
      ],
      "hasImage": false
    },
    {
      "id": 25,
      "questionNumber": 25,
      "questionText": "다음에서 설명하는 미장재료는?\n시멘트와 건조모래 및 특성 개선재를 배합한 공장제품을 현장에서 물만 가하여 사용하는 모르타르로써, 현장배합 모르타르보다는 다소 고가이지만 현장관리가 용이하다.",
      "options": [
        "바라이트 모르타르",
        "셀프레벨링재",
        "초속경 모르타르",
        "드라이 모르타르"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "드라이 모르타르는 공장에서 미리 배합된 건식 모르타르로 현장에서 물만 가하여 사용하는 제품입니다.",
      "tags": [
        "미장",
        "드라이 모르타르",
        "재료"
      ],
      "hasImage": false
    },
    {
      "id": 26,
      "questionNumber": 26,
      "questionText": "다음 보기는 콘크리트 구조물의 동해에 의한 피해현상을 나타낸 것이다. 어느 현상을 설명한 것인가?\n① 콘크리트가 흡수\n② 흡수율이 큰 쇄석이 흡수, 포화상태가 됨\n③ 빙결하여 체적 팽창압력\n④ 표면부분 박리",
      "options": [
        "레이턴스",
        "Pop Out",
        "폭열현상",
        "알칼리골재반응"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "Pop Out은 골재가 동결팽창하여 콘크리트 표면이 박리되는 현상으로, 흡수율이 큰 골재의 동결이 원인입니다.",
      "tags": [
        "콘크리트",
        "Pop Out",
        "동해"
      ],
      "hasImage": true,
      "image": {
        "src": "page_04_bitmap_01.png",
        "description": "문제 26 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-3/page_04_bitmap_01.png"
    },
    {
      "id": 27,
      "questionNumber": 27,
      "questionText": "바차트와 비교한 Network 공정표의 장점이라고 볼 수 없는 것은?",
      "options": [
        "공정계획의 작성시간이 단축된다.",
        "작업 상호간의 관련성을 알기 쉽다.",
        "공기단축 가능요소의 발견이 용이하다.",
        "공사의 진척 관리를 정확히 실시할 수 있다."
      ],
      "correctAnswer": 1,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "Network 공정표는 바차트보다 작성시간이 더 오래 걸립니다. 대신 작업간 관련성 파악과 진척관리에 우수합니다.",
      "tags": [
        "공정관리",
        "네트워크",
        "바차트"
      ],
      "hasImage": false
    },
    {
      "id": 28,
      "questionNumber": 28,
      "questionText": "5t의 시멘트로 용적 배합비 1：2：4의 콘크리트를 비벼낼 때 전체 콘크리트량으로 적당한 것은? (단, W/C=60%)",
      "options": [
        "12m³",
        "15m³",
        "18m³",
        "28m³"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "hard",
      "explanation": "시멘트 5t, 배합비 1:2:4, W/C=60%일 때 콘크리트량은 약 15m³입니다. 시멘트 비중과 배합비를 고려한 계산이 필요합니다.",
      "tags": [
        "콘크리트",
        "배합",
        "용적"
      ],
      "hasImage": false
    },
    {
      "id": 29,
      "questionNumber": 29,
      "questionText": "철골공사에서 크롬산 아연을 안료로 하고, 알키드 수지를 전색료로 한 것으로서 알루미늄 녹막이 초벌칠에 적당한 것은?",
      "options": [
        "광명단",
        "징크로 메이트 도료",
        "그래파이트 도료",
        "알루미늄 도료"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "징크로메이트 도료는 크롬산 아연을 주성분으로 하는 방청도료로 철골의 초벌칠에 사용됩니다.",
      "tags": [
        "철골",
        "도료",
        "방청"
      ],
      "hasImage": false
    },
    {
      "id": 30,
      "questionNumber": 30,
      "questionText": "거푸집 조립순서 중 맞는 것은?",
      "options": [
        "외벽-내벽-기둥-큰보-작은보-바닥",
        "기둥-내벽-큰보-외벽-작은보-바닥",
        "외벽-기둥-내벽-큰보-작은보-바닥",
        "기둥-보받이 내력벽-큰보-작은보-바닥-외벽"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "거푸집 조립은 구조적 순서에 따라 기둥→내력벽→큰보→작은보→바닥→외벽 순으로 진행합니다.",
      "tags": [
        "거푸집",
        "조립순서",
        "시공"
      ],
      "hasImage": false
    },
    {
      "id": 31,
      "questionNumber": 31,
      "questionText": "목재의 방부제처리법 중 가장 효과가 좋은 것은?",
      "options": [
        "도포법",
        "침지법",
        "생리적 주입법",
        "가압주입법"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "가압주입법은 압력을 가하여 방부제를 목재 깊숙이 침투시키는 방법으로 가장 효과적입니다.",
      "tags": [
        "목재",
        "방부처리",
        "가압주입법"
      ],
      "hasImage": false
    },
    {
      "id": 32,
      "questionNumber": 32,
      "questionText": "시멘트 액체방수에 대한 기술 중 옳지 않은 것은?",
      "options": [
        "방수액을 모체에 침투시키거나 방수제를 혼합한 모르타르를 바르는 방수공법이다.",
        "방수 모르타르 바름은 단순히 방수제를 혼합한 모르타르를 2~3회 발라 10~20mm 두께로 한다.",
        "방수층이 넓을 때에는 적당한 위치에 신축줄눈을 시공한다.",
        "하절기에는 낮시간을 이용하여 작업을 실시하여 능률을 높인다."
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "하절기에는 급속한 건조를 방지하기 위해 낮시간 작업을 피하고 아침·저녁 시간에 작업하는 것이 좋습니다.",
      "tags": [
        "방수",
        "시멘트 방수",
        "시공"
      ],
      "hasImage": false
    },
    {
      "id": 33,
      "questionNumber": 33,
      "questionText": "매스콘크리트(Mass concrete)에 대한 설명으로 옳은 것은?",
      "options": [
        "단위시멘트량을 늘려 콘크리트의 발열량을 줄이도록 하여야 한다.",
        "굵은 골재의 최대치수를 작게 하고, 입자의 크기가 균등한 골재를 사용하는 것이 좋다.",
        "매스 콘크리트의 타설온도는 온도균열을 제어하기 위한 관점에서 될 수 있는 대로 낮게 하여야 한다.",
        "매스 콘크리트는 베이스 콘크리트에 유동화제를 첨가하여 유동성을 증가시킨 콘크리트이다."
      ],
      "correctAnswer": 3,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "매스콘크리트는 수화열을 줄이기 위해 타설온도를 낮게 하고, 단위시멘트량도 줄여야 합니다.",
      "tags": [
        "매스콘크리트",
        "수화열",
        "온도균열"
      ],
      "hasImage": false
    },
    {
      "id": 34,
      "questionNumber": 34,
      "questionText": "다음 중 탄성계수를 구할 때 변형 측정에 이용하는 것으로 가장 정밀도가 높은 것은?",
      "options": [
        "다이얼 게이지",
        "콤퍼레이터",
        "마이크로미터",
        "와이어 스트레인 게이지"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "와이어 스트레인 게이지는 미세한 변형도 정확히 측정할 수 있어 탄성계수 측정에 가장 정밀한 장비입니다.",
      "tags": [
        "재료시험",
        "탄성계수",
        "스트레인게이지"
      ],
      "hasImage": false
    },
    {
      "id": 35,
      "questionNumber": 35,
      "questionText": "다음 중 비철금속에 해당되지 않는 것은?",
      "options": [
        "알루미늄",
        "탄소강",
        "동",
        "아연"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "easy",
      "explanation": "탄소강은 철을 주성분으로 하는 철금속입니다. 알루미늄, 동, 아연은 모두 비철금속입니다.",
      "tags": [
        "금속",
        "비철금속",
        "재료"
      ],
      "hasImage": false
    },
    {
      "id": 36,
      "questionNumber": 36,
      "questionText": "콘크리트 블록(Block)벽체의 크기가 3×5m일 때 쌓기 모르타르의 소요량으로 옳은 것은? (단, 블록의 치수는 390×190×190mm, 재료량은 할증이 포함되었으며, 모르타르 배합비는 1:3)",
      "options": [
        "0.10m³",
        "0.12m³",
        "0.15m³",
        "0.18m³"
      ],
      "correctAnswer": 3,
      "subject": "건축시공",
      "difficulty": "hard",
      "explanation": "블록 벽체 3×5m에 대한 모르타르 소요량은 블록 수량과 줄눈 두께를 계산하여 약 0.15m³입니다.",
      "tags": [
        "블록",
        "모르타르",
        "적산"
      ],
      "hasImage": false
    },
    {
      "id": 37,
      "questionNumber": 37,
      "questionText": "금속 커튼월 시공 시 부착철물 설치위치의 연직방향 및 수평방향의 치수 허용차의 표준치로 옳은 것은?",
      "options": [
        "연직방향 : ±5mm, 수평방향 : ±10mm",
        "연직방향 : ±10mm, 수평방향 : ±25mm",
        "연직방향 : ±15mm, 수평방향 : ±25mm",
        "연직방향 : ±25mm, 수평방향 : ±25mm"
      ],
      "correctAnswer": 2,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "금속 커튼월의 부착철물 설치 허용차는 연직방향 ±10mm, 수평방향 ±25mm가 표준입니다.",
      "tags": [
        "커튼월",
        "허용차",
        "시공"
      ],
      "hasImage": false
    },
    {
      "id": 38,
      "questionNumber": 38,
      "questionText": "다음 중 유리섬유(glass fiber)에 대한 설명으로 옳지 않은 것은?",
      "options": [
        "경량이면서 굴곡에 강하다.",
        "단위면적에 따른 인장강도는 다르고, 가는 섬유일수록 인장강도는 크다.",
        "탄성이 적고 전기절연성이 크다.",
        "내화성, 단열성, 내수성이 좋다."
      ],
      "correctAnswer": 1,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "유리섬유는 경량이지만 굴곡에 약한 특성을 가지고 있습니다. 충격에도 취약한 재료입니다.",
      "tags": [
        "유리섬유",
        "재료특성",
        "섬유"
      ],
      "hasImage": false
    },
    {
      "id": 39,
      "questionNumber": 39,
      "questionText": "다음의 창호와 철물과의 조합 중 맞지 않은 것은 어느 것인가?",
      "options": [
        "외여닫이문：도어 체크와 정첩",
        "오르내리창：크레센트와 추",
        "미서기문：레일과 바퀴",
        "쌍 미서기문：도어 힌지와 정첩"
      ],
      "correctAnswer": 4,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "쌍 미서기문은 슬라이딩 방식이므로 도어 힌지나 정첩이 필요하지 않습니다. 레일과 바퀴가 적합합니다.",
      "tags": [
        "창호",
        "철물",
        "조합"
      ],
      "hasImage": false
    },
    {
      "id": 40,
      "questionNumber": 40,
      "questionText": "대규모 공사에서 지역별로 공사 발주시에 사용되며 업자 상호간 경쟁으로 공기단축과 시공기술 향상을 기대할 수 있는 도급방식은?",
      "options": [
        "전문공종별 분할도급",
        "공정별 분할도급",
        "공구별 분할도급",
        "직종별 공종별 분할도급"
      ],
      "correctAnswer": 3,
      "subject": "건축시공",
      "difficulty": "medium",
      "explanation": "공구별 분할도급은 지역별로 나누어 발주하여 업체간 경쟁을 통한 공기단축과 기술향상을 도모하는 방식입니다.",
      "tags": [
        "도급",
        "공구별",
        "분할도급"
      ],
      "hasImage": false
    },
    {
      "id": 41,
      "questionNumber": 41,
      "questionText": "단면의 지름이 150mm, 재축방향 길이가 300mm인 원형 강봉의 윗면에 30kN의 힘이 작용하여 재축방향 길이가 0.16mm 줄어들었고, 단면의 지름이 0.01mm 늘어났다면 이 강봉의 탄성계수 E와 푸아송비는?",
      "options": [
        "31,830MPa, 0.25",
        "31,830MPa, 0.125",
        "39,630MPa, 0.25",
        "39,630MPa, 0.125"
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "hard",
      "explanation": "탄성계수 E = σ/ε = (P/A)/(ΔL/L) = (30,000/(π×75²))/(0.16/300) ≈ 31,830MPa, 푸아송비 ν = (횡변형률)/(종변형률) = (0.01/150)/(0.16/300) = 0.125",
      "tags": [
        "탄성계수",
        "푸아송비",
        "재료역학"
      ],
      "hasImage": false
    },
    {
      "id": 42,
      "questionNumber": 42,
      "questionText": "철근콘크리트 구조물의 처짐에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "휨부재의 크리프와 건조수축에 의한 추가 장기처짐 산정 시 5년 이상의 지속하중에 대한 시간경과 계수는 2.0이다.",
        "과도한 처짐에 의해 손상될 우려가 없는 비구조 요소를 지지한 지붕이나 바닥구조의 처짐한계는 L/180이다.",
        "내부에 보가 없는 2방향 슬래브 중 철근의 항복강도가 400MPa이고 지판이 없는 경우 내부슬래브의 최소 두께는 L/33이다.",
        "처짐을 계산하지 않는 경우 양단연속된 리브가 있는 1방향 슬래브의 최소두께는 L/21이다."
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "비구조 요소를 지지하지 않는 지붕이나 바닥구조의 처짐한계는 L/180이고, 비구조 요소를 지지하는 경우는 L/240입니다.",
      "tags": [
        "철근콘크리트",
        "처짐",
        "한계"
      ],
      "hasImage": false
    },
    {
      "id": 43,
      "questionNumber": 43,
      "questionText": "그림과 같이 단순보의 중앙점에 하중 P가 작용할 때 C점의 처짐은?",
      "options": [
        "PL³/384EI",
        "15PL³/192EI",
        "11PL³/768EI",
        "17PL³/384EI"
      ],
      "correctAnswer": 3,
      "subject": "건축구조",
      "difficulty": "hard",
      "explanation": "단순보에서 중앙점에 집중하중이 작용할 때의 최대처짐은 PL³/48EI이지만, 그림의 조건에 따라 계산하면 11PL³/768EI입니다.",
      "tags": [
        "보",
        "처짐",
        "집중하중"
      ],
      "hasImage": true,
      "image": {
        "src": "image_038.png",
        "description": "문제 43 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-3/image_038.png"
    },
    {
      "id": 44,
      "questionNumber": 44,
      "questionText": "등가정적해석법에 따른 건축물의 내진설계 시 고려해야 할 사항이 아닌 것은?",
      "options": [
        "지역계수",
        "지반종류",
        "지표면조도",
        "반응수정계수"
      ],
      "correctAnswer": 3,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "지표면조도는 풍하중 설계에서 고려하는 사항이고, 내진설계에서는 지역계수, 지반종류, 반응수정계수를 고려합니다.",
      "tags": [
        "내진설계",
        "등가정적해석",
        "설계계수"
      ],
      "hasImage": false
    },
    {
      "id": 45,
      "questionNumber": 45,
      "questionText": "강구조에서 용접선 단부에 붙인 보조판으로 아크의 시작이나 종단부의 크레이터 등의 결함을 방지하기 위해 붙이는 판은?",
      "options": [
        "스티프너",
        "엔드탭",
        "윙플레이트",
        "커버플레이트"
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "엔드탭(End Tab)은 용접선 단부에 붙여 용접 시작과 끝부분의 결함을 방지하는 보조판입니다.",
      "tags": [
        "강구조",
        "용접",
        "엔드탭"
      ],
      "hasImage": false
    },
    {
      "id": 46,
      "questionNumber": 46,
      "questionText": "콘크리트 구조설계 시 철근간격 제한에 관한 내용으로 옳지 않은 것은?",
      "options": [
        "벽체 또는 슬래브에서 휨 주철근의 간격은 벽체나 슬래브 두께의 3배 이하로 하여야 하고, 또한 450mm 이하로 하여야 한다.",
        "상단과 하단에 2단 이상으로 배치된 경우 상하 철근은 동일 연직면 내에 배치되어야 하고, 이때 상하 철근의 순간격은 25mm 이상으로 하여야 한다.",
        "나선철근 또는 띠철근이 배근된 압축부재에서 축방향 철근의 순간격은 25mm 이상, 또한 철근 공칭지름의 2.5배 이상으로 하여야 한다.",
        "2개 이상의 철근을 묶어서 사용하는 다발철근은 이형철근으로, 그 개수는 4개 이하이어야 하며, 이들은 스터럽이나 띠철근으로 둘러 싸여져야 한다."
      ],
      "correctAnswer": 3,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "나선철근 또는 띠철근이 배근된 압축부재에서 축방향 철근의 순간격은 40mm 이상, 또한 철근 공칭지름의 1.5배 이상이어야 합니다.",
      "tags": [
        "철근콘크리트",
        "철근간격",
        "설계기준"
      ],
      "hasImage": false
    },
    {
      "id": 47,
      "questionNumber": 47,
      "questionText": "강구조 접합부에 관한 설명으로 틀린 것은?",
      "options": [
        "기둥-보 접합부는 접합부의 성능과 회전에 대한 구속정도에 따라 전단접합, 부분강접합, 완전강 접합으로 구분된다.",
        "접합부의 설계강도는 45kN 이상이어야 한다. 다만, 연결재, 새그로드 또는 띠장은 제외한다.",
        "강접합은 이론적으로 보 단부에서 회전을 허용하지 않고 100%에 가까운 단부모멘트를 기둥 또는 이음부에 전달시키는 접합부이다.",
        "단순접합은 부재 단부의 회전저항에 따른 단부 모멘트를 발생시킬 수 있는 접합부이다."
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "단순접합은 부재 단부의 회전을 허용하여 모멘트를 전달하지 않는 접합부입니다. 회전저항에 따른 모멘트를 발생시키는 것은 강접합입니다.",
      "tags": [
        "강구조",
        "접합부",
        "분류"
      ],
      "hasImage": false
    },
    {
      "id": 48,
      "questionNumber": 48,
      "questionText": "그림과 같은 1차 부정정 보에서 지점 B의 고정단 모멘트의 크기는?",
      "options": [
        "Mo",
        "Mo/2",
        "Mo/3",
        "Mo/4"
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "hard",
      "explanation": "1차 부정정보에서 고정단 모멘트는 모멘트 분배법을 적용하면 Mo/2가 됩니다.",
      "tags": [
        "구조해석",
        "부정정보",
        "고정단모멘트"
      ],
      "hasImage": true,
      "image": {
        "src": "image_042.png",
        "description": "문제 48 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-3/image_042.png"
    },
    {
      "id": 49,
      "questionNumber": 49,
      "questionText": "다음과 같은 조건에서의 필릿용접의 최소 사이즈는 얼마인가?\n【조 건】접합부의 얇은 쪽 모재두께 (t), mm: 6 < t ≤ 13",
      "options": [
        "3mm",
        "5mm",
        "6mm",
        "8mm"
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "모재두께가 6mm 초과 13mm 이하일 때 필릿용접의 최소 사이즈는 5mm입니다.",
      "tags": [
        "강구조",
        "용접",
        "필릿용접"
      ],
      "hasImage": false
    },
    {
      "id": 50,
      "questionNumber": 50,
      "questionText": "그림과 같은 구조물의 부정정 차수는?",
      "options": [
        "1차 부정정",
        "2차 부정정",
        "3차 부정정",
        "4차 부정정"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "구조물의 부정정 차수는 전체 구속수에서 평형조건수를 뺀 값으로, 그림의 구조물은 4차 부정정입니다.",
      "tags": [
        "구조해석",
        "부정정",
        "차수"
      ],
      "hasImage": true,
      "image": {
        "src": "image_040.png",
        "description": "문제 50 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-3/image_040.png"
    },
    {
      "id": 51,
      "questionNumber": 51,
      "questionText": "그림과 같은 정정라멘에서 BD 부재의 축방향력으로 옳은 것은? (단, + : 인장력, - : 압축력)",
      "options": [
        "5kN",
        "-5kN",
        "10kN",
        "-10kN"
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "정정라멘에서 BD 부재는 압축력을 받으므로 -5kN입니다.",
      "tags": [
        "정정라멘",
        "축방향력",
        "구조해석"
      ],
      "hasImage": true,
      "image": {
        "src": "image_041.png",
        "description": "문제 51 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-3/image_041.png"
    },
    {
      "id": 52,
      "questionNumber": 52,
      "questionText": "피복두께 30mm, 직경 16mm 주근이 배근된 두께 150mm 철근콘크리트 일방향 슬래브에서 전단철근 없이 지지할 수 있는 단위길이 1m당 최대 계수전단력은? (단, fck = 25MPa, γ = 0.75, λ = 1)",
      "options": [
        "70.0 kN",
        "78.5 kN",
        "80.0 kN",
        "82.6 kN"
      ],
      "correctAnswer": 1,
      "subject": "건축구조",
      "difficulty": "hard",
      "explanation": "전단철근이 없는 슬래브의 전단강도는 Vc = 0.17λ√fck·bw·d로 계산하면 약 70.0kN입니다.",
      "tags": [
        "철근콘크리트",
        "전단강도",
        "슬래브"
      ],
      "hasImage": false
    },
    {
      "id": 53,
      "questionNumber": 53,
      "questionText": "강도설계법에서 처짐을 계산하지 않는 경우 스팬 8.0m인 단순지지된 보의 최소두께로 옳은 것은? (단, 보통중량 콘크리트와 fy = 400MPa 철근을 사용한 경우)",
      "options": [
        "380mm",
        "430mm",
        "500mm",
        "600mm"
      ],
      "correctAnswer": 3,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "단순지지 보의 최소두께는 L/16이므로 8000/16 = 500mm입니다.",
      "tags": [
        "철근콘크리트",
        "보",
        "최소두께"
      ],
      "hasImage": false
    },
    {
      "id": 54,
      "questionNumber": 54,
      "questionText": "강도설계법에서 철근콘크리트 구조물의 공칭강도 산정 시 사용되는 강도감소계수로 옳지 않은 것은?",
      "options": [
        "인장지배단면: 0.85",
        "전단력과 비틀림모멘트: 0.75",
        "포스트텐션 정착구역: 0.85",
        "압축지배단면 중 나선철근으로 보강된 철근콘크리트 부재: 0.65"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "나선철근으로 보강된 압축지배단면의 강도감소계수는 0.75입니다. 0.65는 일반 띠철근 보강의 경우입니다.",
      "tags": [
        "강도설계법",
        "강도감소계수",
        "철근콘크리트"
      ],
      "hasImage": false
    },
    {
      "id": 55,
      "questionNumber": 55,
      "questionText": "그림과 같은 내민보에서 A지점의 반력값은?",
      "options": [
        "20kN",
        "30kN",
        "40kN",
        "50kN"
      ],
      "correctAnswer": 4,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "내민보에서 모멘트 평형조건을 적용하여 계산하면 A지점의 반력은 50kN입니다.",
      "tags": [
        "구조해석",
        "내민보",
        "반력"
      ],
      "hasImage": true,
      "image": {
        "src": "image_043.png",
        "description": "문제 55 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-3/image_043.png"
    },
    {
      "id": 56,
      "questionNumber": 56,
      "questionText": "강구조 고장력볼트 접합의 종류에 해당되지 않는 것은?",
      "options": [
        "메탈터치 접합",
        "마찰접합",
        "인장접합",
        "지압접합"
      ],
      "correctAnswer": 1,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "고장력볼트 접합은 마찰접합, 인장접합, 지압접합으로 분류되며, 메탈터치 접합은 일반볼트 접합에 해당합니다.",
      "tags": [
        "강구조",
        "고장력볼트",
        "접합"
      ],
      "hasImage": false
    },
    {
      "id": 57,
      "questionNumber": 57,
      "questionText": "직사각형 단면의 탄성단면계수에 대한 소성단면계수의 비(比)는?",
      "options": [
        "0.67",
        "1.20",
        "1.50",
        "3.00"
      ],
      "correctAnswer": 3,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "직사각형 단면에서 소성단면계수/탄성단면계수 = 1.50입니다.",
      "tags": [
        "단면",
        "소성단면계수",
        "탄성단면계수"
      ],
      "hasImage": false
    },
    {
      "id": 58,
      "questionNumber": 58,
      "questionText": "그림과 같은 ㄷ형강(Channel)에서 전단중심(剪斷中心)의 대략적인 위치는?",
      "options": [
        "A점",
        "B점",
        "C점",
        "D점"
      ],
      "correctAnswer": 1,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "ㄷ형강의 전단중심은 웨브와 플랜지의 교차점 근처에 위치하며, 그림에서 A점에 해당합니다.",
      "tags": [
        "단면",
        "전단중심",
        "ㄷ형강"
      ],
      "hasImage": true,
      "image": {
        "src": "image_045.png",
        "description": "문제 58 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-3/image_045.png"
    },
    {
      "id": 59,
      "questionNumber": 59,
      "questionText": "연약지반에서 부동침하를 방지하기 위한 대책과 가장 관계가 먼 것은?",
      "options": [
        "구조물의 하중을 기초에 균등하게 분포시킨다.",
        "인접 건물과의 거리를 짧게 한다.",
        "기초상호간을 지중보로 연결한다.",
        "기초를 말뚝으로 보강한다."
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "인접 건물과의 거리를 짧게 하는 것은 부동침하 방지와 관계없으며, 오히려 상호 영향을 증가시킬 수 있습니다.",
      "tags": [
        "기초",
        "부동침하",
        "연약지반"
      ],
      "hasImage": false
    },
    {
      "id": 60,
      "questionNumber": 60,
      "questionText": "다음 그림과 같은 두 개의 단순보에 크기가 같은 (P=wL) 하중이 작용할 때, A점에서 발생하는 처짐각의 비율(가:나)은? (단, 부재의 EI는 일정하다.)",
      "options": [
        "1 : 1.5",
        "1.5 : 1",
        "1 : 0.75",
        "0.75 : 1"
      ],
      "correctAnswer": 2,
      "subject": "건축구조",
      "difficulty": "medium",
      "explanation": "집중하중과 분포하중에 의한 처짐각을 비교하면 가:나 = 1.5:1 입니다.",
      "tags": [
        "구조해석",
        "처짐각",
        "하중"
      ],
      "hasImage": true,
      "image": {
        "src": "image_044.png",
        "description": "문제 60 관련 이미지"
      },
      "imagePath": "/images/architectural-engineer/2024/session-3/image_044.png"
    },
    {
      "id": 61,
      "questionNumber": 61,
      "questionText": "자연환기에 관한 설명으로 옳은 것은?",
      "options": [
        "풍력환기에 의한 환기량은 풍속에 반비례한다.",
        "풍력환기에 의한 환기량은 유량계수에 비례한다.",
        "중력환기에 의한 환기량은 공기의 입구와 출구가 되는 두 개구부의 수직거리에 반비례한다.",
        "중력환기에서 실내온도가 외기온도보다 높을 경우 공기는 건물 상부의 개구부에서 실내로 들어와서 하부의 개구부로 나간다."
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "풍력환기량은 유량계수에 비례하고 풍속에 비례합니다. 중력환기는 수직거리에 비례하며, 실내온도가 높을 때는 하부로 유입되어 상부로 배출됩니다.",
      "tags": [
        "환기",
        "자연환기",
        "풍력환기"
      ],
      "hasImage": false
    },
    {
      "id": 62,
      "questionNumber": 62,
      "questionText": "다음 중 수변전실 계획에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "발전기실, 축전지실과 가능한 한 인접장소에 설치한다.",
        "사용부하의 중심에 가깝고 간선의 배선이 용이한 곳으로 한다.",
        "외부로부터 전원을 공급하기 위한 전선로 등의 인입이 편리한 위치로 한다.",
        "빌딩의 변전실은 지하 최저층에 위치시키고 천장 높이는 2.7m 이상으로 한다."
      ],
      "correctAnswer": 4,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "변전실은 침수 위험을 피하기 위해 지하 최저층보다는 적정 높이에 설치하는 것이 바람직합니다.",
      "tags": [
        "전기설비",
        "수변전실",
        "계획"
      ],
      "hasImage": false
    },
    {
      "id": 63,
      "questionNumber": 63,
      "questionText": "다음과 같은 특징을 갖는 전동기는?\n• 구조와 취급이 간단하고 기계적으로 견고하다.\n• 가격이 비교적 싸고 운전이 대체로 쉽다.\n• 건축설비에서 가장 널리 사용되고 있다.",
      "options": [
        "정류자전동기",
        "동기전동기",
        "유도전동기",
        "직류전동기"
      ],
      "correctAnswer": 3,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "유도전동기는 구조가 간단하고 견고하며, 가격이 저렴하여 건축설비에서 가장 널리 사용됩니다.",
      "tags": [
        "전동기",
        "유도전동기",
        "특징"
      ],
      "hasImage": false
    },
    {
      "id": 64,
      "questionNumber": 64,
      "questionText": "음의 세기가 10⁻⁹W/m²일 때 음의 세기 레벨은? (단, 기준음의 세기=10⁻¹²W/m²이다.)",
      "options": [
        "30dB",
        "3dB",
        "0.3dB",
        "0.03dB"
      ],
      "correctAnswer": 1,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "음의 세기 레벨 = 10log(I/I₀) = 10log(10⁻⁹/10⁻¹²) = 10log(10³) = 30dB",
      "tags": [
        "음향",
        "음의 세기",
        "데시벨"
      ],
      "hasImage": false
    },
    {
      "id": 65,
      "questionNumber": 65,
      "questionText": "한 시간당 급탕량이 5m³일 때 급탕부하는 얼마인가? (단, 물의 비열은 4.2kJ/kg·K, 급탕온도는 70℃, 급수온도는 10℃ 이다.)",
      "options": [
        "35kW",
        "126kW",
        "350kW",
        "1,260kW"
      ],
      "correctAnswer": 3,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "급탕부하 = 급탕량 × 물의 밀도 × 비열 × 온도차 / 시간 = 5000 × 4.2 × (70-10) / 3.6 = 350kW",
      "tags": [
        "급탕설비",
        "급탕부하",
        "계산"
      ],
      "hasImage": false
    },
    {
      "id": 66,
      "questionNumber": 66,
      "questionText": "어느 점광원에서 1[m] 떨어진 곳의 직각면 조도가 200[lx]일 때 이 광원에서 2[m] 떨어진 곳의 직각면 조도는?",
      "options": [
        "25[lx]",
        "50[lx]",
        "100[lx]",
        "200[lx]"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "조도는 거리의 제곱에 반비례하므로 200 × (1/2)² = 200 × 1/4 = 50[lx]",
      "tags": [
        "조명",
        "조도",
        "역제곱법칙"
      ],
      "hasImage": false
    },
    {
      "id": 67,
      "questionNumber": 67,
      "questionText": "터보식 냉동기에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "대·중형 규모의 중앙식 공조에서 냉방용으로 사용된다.",
        "기계적 에너지가 아닌 열에너지에 의해 냉동효과를 얻는다.",
        "임펠러의 원심력에 따라 냉매가스를 압축한다.",
        "대용량에서는 압축효율이 좋고 비례 제어가 가능하다."
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "터보식 냉동기는 기계적 에너지(전기)에 의해 작동하며, 열에너지를 사용하는 것은 흡수식 냉동기입니다.",
      "tags": [
        "냉동기",
        "터보식",
        "압축기"
      ],
      "hasImage": false
    },
    {
      "id": 68,
      "questionNumber": 68,
      "questionText": "다음과 같이 정의되는 통기관의 종류는?\n오배수 수직관 내의 압력변동을 방지하기 위하여 오배수 수직관 상향으로 통기수직관에 연결하는 통기관",
      "options": [
        "각개통기관",
        "공용통기관",
        "결합통기관",
        "반송통기관"
      ],
      "correctAnswer": 3,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "결합통기관은 오배수 수직관의 압력변동 방지를 위해 상향으로 통기수직관에 연결하는 통기관입니다.",
      "tags": [
        "급배수설비",
        "통기관",
        "결합통기관"
      ],
      "hasImage": false
    },
    {
      "id": 69,
      "questionNumber": 69,
      "questionText": "다음 중 급수 계통의 오염 원인과 가장 거리가 먼 것은?",
      "options": [
        "급수로의 배수역류",
        "수격작용(Water Hammering)",
        "저수탱크에 유해물질 침입",
        "크로스 커넥션(Cross Connection)"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "수격작용은 급수관의 물리적 손상을 일으킬 수 있지만, 직접적인 수질 오염 원인은 아닙니다.",
      "tags": [
        "급수설비",
        "수질오염",
        "수격작용"
      ],
      "hasImage": false
    },
    {
      "id": 70,
      "questionNumber": 70,
      "questionText": "220[V], 200[W] 전열기를 110[V]에서 사용하였을 경우 소비전력은?",
      "options": [
        "50[W]",
        "100[W]",
        "200[W]",
        "400[W]"
      ],
      "correctAnswer": 1,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "전력은 전압의 제곱에 비례하므로 200 × (110/220)² = 200 × 1/4 = 50[W]",
      "tags": [
        "전기",
        "전력",
        "전압"
      ],
      "hasImage": false
    },
    {
      "id": 71,
      "questionNumber": 71,
      "questionText": "급수설비에서 펌프의 실양정이 의미하는 것은? (단, 물을 높은 곳으로 보내는 경우)",
      "options": [
        "흡수면에서 펌프축 중심까지의 수직거리",
        "흡수면에서 토출수면까지의 수직거리",
        "배관계의 마찰손실에 해당하는 높이",
        "펌프축 중심에서 토출수면까지의 수직거리"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "실양정은 물을 실제로 들어올려야 하는 높이로, 흡수면에서 토출수면까지의 수직거리입니다.",
      "tags": [
        "급수설비",
        "펌프",
        "실양정"
      ],
      "hasImage": false
    },
    {
      "id": 72,
      "questionNumber": 72,
      "questionText": "다음 중 냉방부하 계산 시 현열만을 고려하는 것은?",
      "options": [
        "인체의 발생열량",
        "벽체로부터의 취득열량",
        "극간풍에 따른 취득열량",
        "외기의 도입으로 인한 취득열량"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "벽체로부터의 취득열량은 온도차에 의한 현열만 고려합니다. 인체, 극간풍, 외기는 잠열도 함께 고려해야 합니다.",
      "tags": [
        "공조설비",
        "냉방부하",
        "현열"
      ],
      "hasImage": false
    },
    {
      "id": 73,
      "questionNumber": 73,
      "questionText": "도시가스 설비에서 도시가스 압력을 사용처에 맞게 낮추는 감압 기능을 갖는 것은?",
      "options": [
        "기화기",
        "정압기",
        "압송기",
        "가스홀더"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "정압기(레귤레이터)는 도시가스의 고압을 사용처에 적합한 저압으로 감압하는 장치입니다.",
      "tags": [
        "가스설비",
        "정압기",
        "감압"
      ],
      "hasImage": false
    },
    {
      "id": 74,
      "questionNumber": 74,
      "questionText": "다음 중 방송수신 안테나 시설에 사용하는 설비에 속하지 않는 것은?",
      "options": [
        "신호처리기",
        "모시계",
        "증폭기",
        "레벨조정기"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "모시계는 시계 시설에 사용되는 것으로 방송수신 안테나 시설과는 관련이 없습니다.",
      "tags": [
        "방송설비",
        "안테나",
        "모시계"
      ],
      "hasImage": false
    },
    {
      "id": 75,
      "questionNumber": 75,
      "questionText": "가로, 세로, 높이가 각각 4.5×4.5×3m인 실의 각 벽면 표면온도가 18℃, 천장면 20℃, 바닥면 30℃일 때 평균복사온도(MRT)는?",
      "options": [
        "15.2℃",
        "18.0℃",
        "21.0℃",
        "27.2℃"
      ],
      "correctAnswer": 3,
      "subject": "건축설비",
      "difficulty": "hard",
      "explanation": "평균복사온도는 각 면의 면적과 온도를 가중평균하여 계산하면 약 21.0℃입니다.",
      "tags": [
        "공조설비",
        "평균복사온도",
        "실내환경"
      ],
      "hasImage": false
    },
    {
      "id": 76,
      "questionNumber": 76,
      "questionText": "다음의 에스컬레이터의 경사도에 관한 설명 중 ( ) 안에 알맞은 것은?\n에스컬레이터의 경사도는 ( ㉠ )를 초과하지 않아야 한다. 다만, 높이가 6m 이하이고 공칭속도가 0.5m/s 이하인 경우에는 경사도를 ( ㉡ )까지 증가시킬 수 있다.",
      "options": [
        "㉠ 25°, ㉡ 30°",
        "㉠ 25°, ㉡ 35°",
        "㉠ 30°, ㉡ 35°",
        "㉠ 30°, ㉡ 40°"
      ],
      "correctAnswer": 3,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "에스컬레이터의 경사도는 일반적으로 30°를 초과하지 않아야 하며, 특별한 조건에서는 35°까지 허용됩니다.",
      "tags": [
        "승강기",
        "에스컬레이터",
        "경사도"
      ],
      "hasImage": false
    },
    {
      "id": 77,
      "questionNumber": 77,
      "questionText": "구조체를 가열하는 복사난방에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "복사열에 의하므로 쾌적성이 좋다.",
        "바닥, 벽체, 천장 등을 방열면으로 할 수 있다.",
        "예열시간이 길고 일시적인 난방에는 바람직하지 않다.",
        "방열기의 설치로 인해 실의 바닥면적의 이용도가 낮다."
      ],
      "correctAnswer": 4,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "복사난방은 별도의 방열기가 필요 없고 구조체 자체가 방열면이 되므로 바닥면적 이용도가 높습니다.",
      "tags": [
        "난방설비",
        "복사난방",
        "방열기"
      ],
      "hasImage": false
    },
    {
      "id": 78,
      "questionNumber": 78,
      "questionText": "다음은 옥내소화전설비에서 전동기에 따른 펌프를 이용하는 가압송수장치에 관한 설명이다. ( )안에 알맞은 것은?\n펌프의 토출량은 옥내소화전이 가장 많이 설치된 층의 설치개수(옥내소화전이 2개 이상 설치된 경우에는 2개)에 ( )를 곱한 양 이상이 되도록 하여야 한다.",
      "options": [
        "70L/min",
        "130L/min",
        "260L/min",
        "350L/min"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "옥내소화전 1개당 130L/min의 방수량이 필요하므로 130L/min을 곱해야 합니다.",
      "tags": [
        "소방설비",
        "옥내소화전",
        "펌프"
      ],
      "hasImage": false
    },
    {
      "id": 79,
      "questionNumber": 79,
      "questionText": "공기조화방식 중 단일덕트 변풍량방식에 관한 설명으로 옳지 않은 것은?",
      "options": [
        "전공기방식의 특성이 있다.",
        "각 실이나 존의 온도를 개별제어할 수 있다.",
        "단일덕트 정풍량방식보다 설비비가 적게 든다.",
        "실내부하가 적어지면 송풍량을 줄일 수 있으므로 에너지 절감효과가 크다."
      ],
      "correctAnswer": 3,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "변풍량방식은 VAV 박스 등 추가 설비가 필요하여 정풍량방식보다 설비비가 많이 듭니다.",
      "tags": [
        "공조설비",
        "VAV",
        "변풍량"
      ],
      "hasImage": false
    },
    {
      "id": 80,
      "questionNumber": 80,
      "questionText": "건구온도 25℃인 실내공기 8,000m³/h와 건구온도 31℃인 외부공기 2,000m³/h를 단열혼합하였을 때 혼합공기의 건구온도는?",
      "options": [
        "24.8℃",
        "26.2℃",
        "27.5℃",
        "29.8℃"
      ],
      "correctAnswer": 2,
      "subject": "건축설비",
      "difficulty": "medium",
      "explanation": "혼합온도 = (25×8000 + 31×2000)/(8000+2000) = 262,000/10,000 = 26.2℃",
      "tags": [
        "공조설비",
        "혼합공기",
        "온도"
      ],
      "hasImage": false
    },
    {
      "id": 81,
      "questionNumber": 81,
      "questionText": "범죄예방 기준에 따라 건축하여야 하는 대상 건축물에 속하지 않는 것은?",
      "options": [
        "수련시설",
        "업무시설 중 오피스텔",
        "숙박시설 중 일반숙박시설",
        "아파트"
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "일반숙박시설은 범죄예방 기준 적용 대상이 아닙니다. 수련시설, 오피스텔, 아파트는 적용 대상입니다.",
      "tags": [
        "건축법",
        "범죄예방",
        "대상건축물"
      ],
      "hasImage": false
    },
    {
      "id": 82,
      "questionNumber": 82,
      "questionText": "면적 등의 산정방법에 대한 기본 원칙으로 옳지 않은 것은?",
      "options": [
        "대지면적은 대지의 수평투영면적으로 한다.",
        "건축면적은 건축물의 외벽의 중심선으로 둘러싸인 부분의 수평투영면적으로 한다.",
        "바닥면적은 건축물의 각 층 또는 그 일부로서 벽, 기둥, 그 밖에 이와 비슷한 구획의 중심선으로 둘러싸인 부분의 수평투영면적으로 한다.",
        "용적률 산정 시 적용하는 연면적은 지하층을 포함하여 하나의 건축물 각 층의 바닥면적의 합계로 한다."
      ],
      "correctAnswer": 4,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "용적률 산정 시 연면적은 지하층을 제외한 지상층의 바닥면적 합계로 계산합니다.",
      "tags": [
        "건축법",
        "면적산정",
        "용적률"
      ],
      "hasImage": false
    },
    {
      "id": 83,
      "questionNumber": 83,
      "questionText": "다음과 같은 경우 연면적 1,000m²인 건축물의 대지에 확보하여야 하는 전기설비 설치공간의 면적기준은?\n• 수전전압 : 저압\n• 전력수전 용량 : 200kW",
      "options": [
        "가로 2.5m, 세로 2.8m",
        "가로 2.5m, 세로 4.6m",
        "가로 2.8m, 세로 2.8m",
        "가로 2.8m, 세로 4.6m"
      ],
      "correctAnswer": 4,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "저압 수전이고 200kW 용량일 때 전기설비 설치공간은 가로 2.8m, 세로 4.6m 이상이어야 합니다.",
      "tags": [
        "건축법",
        "전기설비",
        "공간기준"
      ],
      "hasImage": false
    },
    {
      "id": 84,
      "questionNumber": 84,
      "questionText": "다음 중 건축법상 건축물의 용도 구분에 속하지 않는 것은? (단, 대통령령으로 정하는 세부 용도는 제외)",
      "options": [
        "공장",
        "교육시설",
        "묘지 관련 시설",
        "자원순환 관련 시설"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "묘지 관련 시설은 건축법상 건축물의 용도 구분에 포함되지 않습니다.",
      "tags": [
        "건축법",
        "용도구분",
        "시설"
      ],
      "hasImage": false
    },
    {
      "id": 85,
      "questionNumber": 85,
      "questionText": "다음 중 내화구조에 해당하지 않는 것은?",
      "options": [
        "벽의 경우 철재로 보강된 콘크리트블록조·벽돌조 또는 석조로서 철재에 덮은 콘크리트 블록 등의 두께가 3cm 이상인 것",
        "기둥의 경우 철근콘크리트구조로서 그 작은 지름이 25cm 이상인 것",
        "바닥의 경우 철근콘크리트조로서 두께가 10cm 이상인 것",
        "철근콘크리트조로 된 보"
      ],
      "correctAnswer": 1,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "벽의 내화구조에서 콘크리트 피복 두께는 5cm 이상이어야 하며, 3cm는 기준에 미달됩니다.",
      "tags": [
        "건축법",
        "내화구조",
        "기준"
      ],
      "hasImage": false
    },
    {
      "id": 86,
      "questionNumber": 86,
      "questionText": "시가화조정구역의 지정과 관련된 기준 내용 중 밑줄 친 \"대통령령으로 정하는 기간\"으로 옳은 것은?\n시·도지사는 직접 또는 관계 행정기관의 장의 요청을 받아 도시지역과 그 주변 지역의 무질서한 시가화를 방지하고 계획적·단계적인 개발을 도모하기 위하여 대통령령으로 정하는 기간 동안 시가화를 유보할 필요가 있다고 인정되면 시가화 조정구역의 지정 또는 변경을 도시·군 관리계획으로 결정할 수 있다.",
      "options": [
        "출구너비",
        "반자높이",
        "평면길이",
        "벽체두께"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "시가화조정구역은 5년의 기간으로 지정할 수 있으며, 이는 반자높이와 관련된 기준입니다.",
      "tags": [
        "도시계획",
        "시가화조정구역",
        "기간"
      ],
      "hasImage": false
    },
    {
      "id": 87,
      "questionNumber": 87,
      "questionText": "설치하여야 하는 부설주차장의 최소 규모(설치 대수)의 크기 관계가 옳은 것은?\n• 시설면적이 600m²인 위락시설\n• 시설면적이 800m²인 숙박시설\n• 타석수가 5타석인 골프연습장\n• 시설면적이 900m²인 판매시설",
      "options": [
        "㉠=㉣>㉢>㉡",
        "㉠>㉣=㉢>㉡",
        "㉢>㉣>㉠>㉡",
        "㉢>㉣=㉠>㉡"
      ],
      "correctAnswer": 1,
      "subject": "건축법규",
      "difficulty": "hard",
      "explanation": "주차장 설치 기준에 따라 위락시설과 판매시설이 가장 많고, 다음이 골프연습장, 숙박시설 순입니다.",
      "tags": [
        "건축법",
        "주차장",
        "설치기준"
      ],
      "hasImage": false
    },
    {
      "id": 88,
      "questionNumber": 88,
      "questionText": "지하식 또는 건축물식 노외주차장에서 경사로가 직선형인 경우, 경사로의 차로 너비는 최소 얼마 이상으로 하여야 하는가? (단, 2차로인 경우)",
      "options": [
        "5m",
        "6m",
        "7m",
        "8m"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "지하식 노외주차장의 직선형 경사로에서 2차로인 경우 차로 너비는 최소 6m 이상이어야 합니다.",
      "tags": [
        "주차장법",
        "경사로",
        "차로너비"
      ],
      "hasImage": false
    },
    {
      "id": 89,
      "questionNumber": 89,
      "questionText": "급수, 배수, 환기, 난방 설비를 건축물에 설치하는 경우, 건축기계설비기술사 또는 공조냉동기계기술사의 협력을 받아야 하는 대상 건축물에 속하지 않는 것은?",
      "options": [
        "아파트",
        "연립주택",
        "기숙사로서 해당 용도에 사용되는 바닥면적의 합계가 2,000m²인 건축물",
        "업무시설로서 해당 용도에 사용되는 바닥면적의 합계가 2,000m²인 건축물"
      ],
      "correctAnswer": 4,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "업무시설은 바닥면적 3,000m² 이상일 때 기술사 협력이 필요하므로, 2,000m²는 해당되지 않습니다.",
      "tags": [
        "건축법",
        "기계설비",
        "기술사협력"
      ],
      "hasImage": false
    },
    {
      "id": 90,
      "questionNumber": 90,
      "questionText": "다음의 피난계단의 설치에 관한 기준 내용 중 ( ) 안에 알맞은 것은?\n5층 이상 또는 지하 2층 이하인 층에 설치하는 직통계단은 피난계단 또는 특별피난계단으로 설치하여야 하는데, ( )의 용도로 쓰는 층으로부터의 직통계단은 그 중 1개소 이상을 특별피난계단으로 설치하여야 한다.",
      "options": [
        "의료시설",
        "숙박시설",
        "판매시설",
        "교육연구시설"
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "판매시설은 화재 위험성이 높아 특별피난계단 설치가 의무화되어 있습니다.",
      "tags": [
        "건축법",
        "피난계단",
        "특별피난계단"
      ],
      "hasImage": false
    },
    {
      "id": 91,
      "questionNumber": 91,
      "questionText": "대지 면적이 1,000m²인 건축물의 옥상에 조경 면적을 90m² 설치한 경우, 대지에 설치하여야 하는 최소 조경면적은? (단, 조경설치기준은 대지면적의 10%)",
      "options": [
        "10m²",
        "40m²",
        "50m²",
        "100m²"
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "필요 조경면적 100m² - 옥상 조경면적 90m²×1/2 = 100 - 45 = 55m², 가장 가까운 답은 50m²입니다.",
      "tags": [
        "건축법",
        "조경",
        "면적기준"
      ],
      "hasImage": false
    },
    {
      "id": 92,
      "questionNumber": 92,
      "questionText": "지구단위계획 중 관계 행정기관의 장과의 협의, 국토교통부장관과의 협의 및 중앙도시계획위원회·지방도시계획위원회 또는 공동위원회의 심의를 거치지 아니하고 변경할 수 있는 사항에 관한 기준 내용으로 옳은 것은?",
      "options": [
        "건축선의 2m 이내의 변경인 경우",
        "획지면적의 30% 이내의 변경인 경우",
        "가구면적의 20% 이내의 변경인 경우",
        "건축물 높이의 30% 이내의 변경인 경우"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "지구단위계획에서 획지면적의 30% 이내 변경은 간소한 절차로 가능합니다.",
      "tags": [
        "도시계획",
        "지구단위계획",
        "변경기준"
      ],
      "hasImage": false
    },
    {
      "id": 93,
      "questionNumber": 93,
      "questionText": "건축법령에 따른 리모델링이 쉬운 구조에 속하지 않는 것은?",
      "options": [
        "구조체가 철골구조로 구성되어 있을 것",
        "구조체에서 건축설비, 내부 마감재료 및 외부 마감재료를 분리할 수 있을 것",
        "개별 세대 안에서 구획된 실의 크기, 개수 또는 위치 등을 변경할 수 있을 것",
        "각 세대는 인접한 세대와 수직 또는 수평방향으로 통합하거나 분할할 수 있을 것"
      ],
      "correctAnswer": 1,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "철골구조는 리모델링이 쉬운 구조가 아닙니다. 철근콘크리트 라멘구조 등이 리모델링에 적합합니다.",
      "tags": [
        "건축법",
        "리모델링",
        "구조"
      ],
      "hasImage": false
    },
    {
      "id": 94,
      "questionNumber": 94,
      "questionText": "국토의 계획 및 이용에 관한 법령상 제2종 전용주거지역안에서 건축할 수 있는 건축물에 속하지 않는 것은?",
      "options": [
        "공동주택",
        "판매시설",
        "노유자시설",
        "교육연구시설 중·고등학교"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "제2종 전용주거지역에서는 판매시설의 건축이 제한됩니다.",
      "tags": [
        "도시계획",
        "용도지역",
        "건축제한"
      ],
      "hasImage": false
    },
    {
      "id": 95,
      "questionNumber": 95,
      "questionText": "건축지도원에 관한 설명으로 틀린 것은?",
      "options": [
        "허가를 받지 아니하고 건축하거나 용도변경한 건축물의 단속 업무를 수행한다.",
        "건축지도원은 시장, 군수, 구청장이 지정할 수 있다.",
        "건축지도원의 자격과 업무범위는 국토교통부령으로 정한다.",
        "건축신고를 하고 건축 중에 있는 건축물의 시공 지도와 위법 시공 여부의 확인·지도 및 단속 업무를 수행한다."
      ],
      "correctAnswer": 3,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "건축지도원의 자격과 업무범위는 시·도의 조례로 정합니다.",
      "tags": [
        "건축법",
        "건축지도원",
        "자격"
      ],
      "hasImage": false
    },
    {
      "id": 96,
      "questionNumber": 96,
      "questionText": "건축물로부터 바깥쪽으로 나가는 출구를 국토교통부령으로 정하는 기준에 따라 설치하여야 하는 대상 건축물에 속하지 않는 것은?",
      "options": [
        "종교시설",
        "의료시설 중 종합병원",
        "교육연구시설 중 학교",
        "문화 및 집회시설 중 관람장"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "의료시설 중 종합병원은 별도의 출구 설치 기준이 적용되지 않습니다.",
      "tags": [
        "건축법",
        "출구",
        "대상건축물"
      ],
      "hasImage": false
    },
    {
      "id": 97,
      "questionNumber": 97,
      "questionText": "피난층 이외 층으로서 피난층 또는 지상으로 통하는 직통계단을 2개소 이상 설치하여야 하는 대상기준으로 옳지 않은 것은?",
      "options": [
        "지하층으로서 그 층 거실의 바닥면적의 합계가 200m² 이상인 것",
        "종교시설의 용도로 쓰는 층으로서 그 층에서 해당 용도로 쓰는 바닥면적의 합계가 200m² 이상인 것",
        "판매시설의 용도로 쓰는 3층 이상의 층으로서 그 층의 해당 용도로 쓰는 거실의 바닥면적의 합계가 200m² 이상인 것",
        "업무시설 중 오피스텔의 용도로 쓰는 층으로서 그 층의 해당 용도로 쓰는 거실의 바닥면적의 합계가 200m² 이상인 것"
      ],
      "correctAnswer": 4,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "오피스텔은 직통계단 2개소 설치 의무 대상이 아닙니다.",
      "tags": [
        "건축법",
        "직통계단",
        "설치기준"
      ],
      "hasImage": false
    },
    {
      "id": 98,
      "questionNumber": 98,
      "questionText": "주거용 건축물 급수관의 지름 산정에 관한 기준 내용으로 틀린 것은?",
      "options": [
        "가구 또는 세대수가 1일 때 급수관 지름의 최소기준은 15mm이다.",
        "가구 또는 세대수가 7일 때 급수관 지름의 최소기준은 25mm이다.",
        "가구 또는 세대수가 18일 때 급수관 지름의 최소기준은 50mm이다.",
        "가구 또는 세대의 구분이 불분명한 건축물에 있어서는 주거에 쓰이는 바닥면적의 합계가 85m² 초과 150m² 이하인 경우는 3가구로 산정한다."
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "가구 또는 세대수가 7일 때 급수관 지름의 최소기준은 20mm입니다.",
      "tags": [
        "건축법",
        "급수관",
        "지름기준"
      ],
      "hasImage": false
    },
    {
      "id": 99,
      "questionNumber": 99,
      "questionText": "다음 중 도시·군관리계획에 포함되지 않는 것은?",
      "options": [
        "도시개발사업이나 정비사업에 관한 계획",
        "광역계획권의 장기발전방향을 제시하는 계획",
        "기반시설의 설치·정비 또는 개량에 관한 계획",
        "용도지역·용도지구의 지정 또는 변경에 관한 계획"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "광역계획권의 장기발전방향은 광역도시계획에 포함되는 내용으로 도시·군관리계획에는 포함되지 않습니다.",
      "tags": [
        "도시계획",
        "관리계획",
        "내용"
      ],
      "hasImage": false
    },
    {
      "id": 100,
      "questionNumber": 100,
      "questionText": "건축허가신청에 필요한 설계도서의 종류 중 건축계획서에 표시하여야 할 사항이 아닌 것은?",
      "options": [
        "주차장규모",
        "대지의 종·횡 단면도",
        "건축물의 용도별 면적",
        "지역·지구 및 도시계획사항"
      ],
      "correctAnswer": 2,
      "subject": "건축법규",
      "difficulty": "medium",
      "explanation": "대지의 종·횡 단면도는 별도의 도면으로 작성하며, 건축계획서에 표시할 사항이 아닙니다.",
      "tags": [
        "건축법",
        "건축계획서",
        "표시사항"
      ],
      "hasImage": false
    }
  ]
};

// 시험 기본 정보
export const getExamInfo = () => examSession.examInfo;

// 문제 목록
export const getQuestions = () => examSession.questions;

// 특정 문제 조회
export const getQuestion = (questionNumber) => {
  return examSession.questions.find(q => q.questionNumber === questionNumber);
};

// 이미지 URL 생성
export const getImageUrl = (imageName) => {
  return examSession.examInfo.imageBasePath + imageName;
};

export default examSession;
